import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'
import {useParams} from 'react-router-dom'
import {Alert, Button, Form, Modal, Skeleton, Space} from 'antd'
import {JSONSchema7} from 'json-schema'
import {AlertWrapper, MapContent, MapTitle, MapWrapper, TaskWrapper} from './styles'
import B2BLayout from '../../layouts/b2b'
import fetchAPI from 'src/lib/utils/fetch-api'
import {getDataOfType} from 'src/lib/utils/get-data-of-type'
import {DefaultJsonForm} from '../../components/default-json-form'
import EventRibbonTab from 'src/react-app/forms/case-event-ribbon-tab'
import {createUISchemaHorizontal, recalcUISchemaHorizontal} from 'src/lib/utils/grid-fild-orientation'
import ButtonAddNotes from 'src/react-app/views/modal-add-notes'
import {debounce} from 'lodash'
import {
  addActionsTimeLine,
  clearCaseStore,
  initialCase,
  reloadActionsTimeLine,
  reloadTablePayment,
  setAppealStage,
  setCaseId,
  setTargetId
} from 'src/react-app/store/appeals/actions'
import {useSelector} from 'react-redux'
import StepCollectionObject from 'src/react-app/views/step-collection-object'
import {createSelector} from 'reselect'
import StepButtonsTransition from 'src/react-app/views/step-buttons-transition'
import {
  accessUISchema,
  addValidateFieldsUISchema,
  isFormDataDifferenceFilesS3
} from 'src/react-app/pages/card-order/utils'
import {isFormDataRequired} from 'src/lib/utils/collections'
import StuckFiles from 'src/react-app/components/tab-stuck-files'
import TableProduct from 'src/react-app/connectors/json-form-product-table/adaptor-tab'
import {isProductsSpcificationStage, setStageFromCard} from 'src/lib/utils/cards'
import dayjs from 'dayjs'
import {modalAdjustedDate} from 'src/react-app/views/modal-adjusted-date'
import {insetNoteToCollection} from 'src/react-app/views/modal-add-notes/utils-notes'
import { useAppDispatch } from '../../hooks/useAppDispatch/useAppDispatch'

function genJSONSchemaStage(JSONSchema, requiredArr){
  const required = getDataOfType(JSONSchema, 'required', Array, []).concat(requiredArr)
  const requiredUnic = Array.from(new Set(required))
  return ({ ...JSONSchema, required: requiredUnic })
}

function genJSONSchemaNamesrequired(JSONSchema){
  return getDataOfType(JSONSchema, 'required', Array, [])
}

const createAppealsCurrentStep = createSelector(
  (state: any) => state.appeals,
  appealsCurrentStep => appealsCurrentStep,
  workflows => workflows,
  targetId => targetId,
  tablePayment => tablePayment
)
const createSession = createSelector(
  (state: any) => state.session,
  sessionData => sessionData
)

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
}

const breadcrumbs = [{
  href: '/production-page',
  title: 'Производство',
}, {
  href: `/production-page`,
  title:  'Список заказов на изготовление',
}]

const name = 'card-manufacture'
const cardName = 'manufacture'

export default function AdminNewObjectPage() {
  const { id } = useParams()  as any
  const [orderNumber, setOrderNumber] = useState<any>(null)
  const dispatch = useAppDispatch()
  const parentIdRef = useRef<any>(null)
  const [isStageTransitioning, setIsStageTransitioning] = useState(false)
  const stageTransitionLockRef = useRef(false)
  const [isDataLoading, setIsDataLoading] = useState<Boolean>(true)
  const [pageErrors, setPageErrors] = useState<string[]>([])
  const [selectedSchema, setSelectedSchema] = useState<string[]>([])
  const formDataRef = useRef<any>(null)
  const [matchedJSONSchema, setMatchedJSONSchema] = useState<JSONSchema7 | null>(null)
  const [UISchema, setUISchema] = useState<any>(null)
  const [form] = Form.useForm()
  const { appealsCurrentStep, workflows, targetId, tablePayment } = useSelector(createAppealsCurrentStep)
  const { sessionData } = useSelector(createSession)

  useEffect(() => {
    const currentStageAccess = getDataOfType(workflows, `${cardName}[${appealsCurrentStep}].access-rights`, Array, null)
    if(currentStageAccess === null){
      return
    }

    setUISchema(UISchema => {
      const actualUISchema = accessUISchema(UISchema || {}, currentStageAccess, sessionData)
      if( actualUISchema['act-shipment-manufacture'] ) {
        actualUISchema['act-shipment-manufacture'].options.disabled = true
        if (appealsCurrentStep === 2) {
          actualUISchema['act-shipment-manufacture'].options.disabled = (tablePayment?.sum - tablePayment?.paymentsSumAll > 0)
        }
      }
      return recalcUISchemaHorizontal(actualUISchema)
    })

  },[workflows, appealsCurrentStep, sessionData, tablePayment])

  const tableProductDisabled = useMemo(() => {
    return [2,3].indexOf( appealsCurrentStep ) !== -1
  }, [appealsCurrentStep])

  const custumTabs = useMemo(() => ({
    'stuck-products': {
      isVirtual: true,
      schema: {
        properties: {
          'stuck-products': {
            title: 'Данные заказа',
            description: null,
          }
        }
      },
      render: () => <TableProduct currentStage={cardName} disabled={tableProductDisabled} id={id} options={{ buttons: ['print'] }} />
    },
    'stuck-files': {
      isVirtual: true,
      schema: {
        properties: {
          'stuck-files': {
            title: 'Прикрепленные файлы',
            description: null,
          }
        }
      },
      render: () => <StuckFiles />
    },
    'event-ribbon': EventRibbonTab
  }), [id, tableProductDisabled])

  const saveCase = useCallback(debounce(async formData => {
     const requestBody = {
       data: {
         name: '',
         title: '',
         attributes: formData,
         metadata: { schema: name }
       }
     }

     const result = await fetchAPI(`/api/collections/-/objects/${id}`, {
       method: 'POST',
       body: JSON.stringify(requestBody),
     })

     const updated = getDataOfType(result, 'data.updated-at', [String, Number], null)
     if (updated === null) {
       console.warn('Ошибка сохранения записи')
     }
  }, 1000), [])

  useEffect(() => {
    dispatch(initialCase({ targetId: null, cardName: cardName }))
    const result = setCaseId({ caseId: id, parentIds: [id] })
    dispatch(result)
    return () => { dispatch(clearCaseStore()) }
  }, [id, dispatch])

  const getData = useCallback(async () => {
    const fields = [
      'title',
      'description',
      'type',
      'properties',
      'required',
      'created_by',
      'created_at',
      'updated_at',
    ].join(',')
    const responseSchemas = await fetchAPI(`/api/schemas?access_key=axioma&fields=${fields}`)
    const fetchedSchemas: JSONSchema7[] = getDataOfType(responseSchemas, 'data.data', Array, [])
    const selectedSchemas = fetchedSchemas.filter(item => item['name'] === name)
    const selectedSchema = (typeof selectedSchemas[0] === 'object') ? selectedSchemas[0] : null
    if (selectedSchema === null) {
      setPageErrors(['Некорректный ответ сервера при схемы коллекции'])
      return
    }

    const responseObject = await fetchAPI(`/api/collections/objects/${id}`)
    const object = responseObject['data']
    const schema = object['data']['metadata']['schema']
    const formData = object['data']['attributes']
    const caseId = Number(formData.caseId || 0)
    const parentId = Number(object['parent-id'])
    const stageCode = getDataOfType(object, 'stage-code', String, null)
    dispatch(setTargetId({ targetId: parentId }))
    setOrderNumber(object['parent-id'] || null)
    parentIdRef.current = Number(parentId)

    const parentIds = [parentId]
    if(caseId)
      parentIds.push(caseId)

    if(Boolean(Number(parentId)))
      dispatch(setCaseId({ caseId: parentId, parentIds }))

    if( selectedSchema.required ) {
      if (stageCode === 'new')
        selectedSchema.required = [...selectedSchema.required, 'production-order-number', 'number-contract', 'scan-spec-products', 'contract-scan']
      if (stageCode === 'expect-shipment')
        selectedSchema.required = [...selectedSchema.required, 'act-shipment-manufacture']
    }

    setSelectedSchema(schema)
    if(object['created-at']){
      const paramsDispatch = addActionsTimeLine({ type: 'info', items: [
        {
          date: object['created-at'],
          text: 'Создание записи'
        }
      ]})
      dispatch(paramsDispatch)
    }
    dispatch(setAppealStage({ stageCode: stageCode, type: cardName, isHistory: false }))

    setPageErrors([])
    formDataRef.current = formData
    const stage = formData['stage'] || 0
    setMatchedJSONSchema(selectedSchema)
    const UISchema = createUISchemaHorizontal(selectedSchema)
    setUISchema(UISchema)
    const currentStageAccess = getDataOfType(workflows, `${cardName}[${stage}].access-rights`, Array, [])

    setUISchema(UISchema => {
      const actualUISchema = accessUISchema(UISchema || {}, currentStageAccess, sessionData)
      if( actualUISchema['act-shipment-manufacture'] ) {
        actualUISchema['act-shipment-manufacture'].options.disabled = true
        if( stage === 2 )
          actualUISchema['act-shipment-manufacture'].options.disabled = (tablePayment?.sum - tablePayment?.paymentsSumAll > 0)
      }
      return recalcUISchemaHorizontal(actualUISchema)
    })
    setIsDataLoading(!(tablePayment && tablePayment?.targetId && workflows)) // отрисовать форму только когда данные получены
  }, [dispatch, id, sessionData, workflows, tablePayment])

  useEffect(() => {
    if(sessionData === null || workflows === null){
      return
    }
    if(!tablePayment || !tablePayment?.targetId)
      dispatch(reloadTablePayment())
    getData()
  }, [getData, sessionData, workflows, tablePayment, dispatch])

  const onFormData = useCallback(
    ({ formData }) => {
      const isFilesEdit = isFormDataDifferenceFilesS3(formDataRef.current, formData, matchedJSONSchema)
      if (isFilesEdit) {
        dispatch(reloadActionsTimeLine())
      }
      const nextFormData = { ...formData, stage: appealsCurrentStep }
      formDataRef.current = nextFormData
      saveCase(nextFormData)
    },
    [saveCase, appealsCurrentStep, matchedJSONSchema, dispatch],
  )

  const transition = useCallback(async transition => {
    if (stageTransitionLockRef.current) {
      return
    }
    stageTransitionLockRef.current = true
    setIsStageTransitioning(true)
    try {
      const stageCodeNext: string = transition['target']

      setMatchedJSONSchema(matchedJSONSchema => {
        if( matchedJSONSchema?.required ) {
          if (stageCodeNext === 'expect-shipment')
            matchedJSONSchema.required.push('act-shipment-manufacture')
        }
        return matchedJSONSchema
      })

      if (stageCodeNext === 'shipped-from-production') {
        const isProducts = await isProductsSpcificationStage(targetId, 'manufacture')
        if (!isProducts) {
          Modal.info({
            icon: null,
            title: 'Не передана продукция',
            content: 'Выберите продукцию для внесения в акт приема-передачи'
          })
          return
        }
      // Отключена проверка на отгрузку водителем
      /*
      const result2 = await getObjectFirst({ collectionName: 'card-delivery', 'parentId': targetId })
      const isNotDone = ['new', 'work', 'expect-shipment'].includes(getDataOfType(result2, 'stage-code', String, 'new'))
      if (isNotDone) {
      Modal.warning({
        title: 'Не удалось изменить стадию',
        content: 'Экипаж не принял груз',
      })
       return
      }
      */
      }
      const nextDataCard = await setStageFromCard({
        cardName: cardName, stageCode: stageCodeNext, targetId: targetId, isHistory: true
      })
      dispatch(reloadActionsTimeLine())
      dispatch(setAppealStage({ stageCode: getDataOfType(nextDataCard, 'data.nextStageCode', String, null), type: cardName, isHistory: false }))
      formDataRef.current = getDataOfType(nextDataCard, 'data.formData', Object, null)
    } finally {
      stageTransitionLockRef.current = false
      setIsStageTransitioning(false)
    }
  },[dispatch, targetId, UISchema, tablePayment])

const transitionRequired = useCallback((_, nextFields) => {
  const gen = genJSONSchemaStage(matchedJSONSchema, nextFields)
  const names = genJSONSchemaNamesrequired(gen)
  const isRequired = isFormDataRequired(formDataRef.current, gen)
  if(isRequired){
    return true
  }
  setUISchema(UISchema => addValidateFieldsUISchema(UISchema, names))
  return false
}, [matchedJSONSchema])

const isAadjusted = useMemo(() => {
  return [1].includes(appealsCurrentStep)
}, [appealsCurrentStep])

const onModalAdjustedDate = useCallback(async () => {
  const authorId = getDataOfType(sessionData, 'user.id', Number, 0)
  const result = await modalAdjustedDate()
  if (result === null) {
    return
  }
  const { date, comment, time } = result as any
  const content = `Изменена дата производста на: ${dayjs(date).format('DD.MM.YYYY')}. ${comment ?? ''}`
  const nextDataCard = await fetchAPI('/api/web-hooks/set-card-form-data', { method: 'POST', body: JSON.stringify({
    'card-name': cardName,
    'target-id': targetId,
    'add-form-data': {
      'date-adjusted-manufacture': date, 'time-adjusted-manufacture': time
    }
  })})
  formDataRef.current = getDataOfType(nextDataCard, 'data.formData', Object, null)
  await insetNoteToCollection({ date: new Date().toISOString(), content: content, author: authorId }, targetId)
  dispatch(reloadActionsTimeLine())
}, [sessionData, targetId, dispatch])

  return (
    <B2BLayout breadcrumbs={breadcrumbs}>
      <MapWrapper>
        <TaskWrapper>
          <MapTitle>Заказ №{orderNumber}</MapTitle>
          <Space size={'small'}>
            <ButtonAddNotes />
            {isAadjusted && <Button onClick={onModalAdjustedDate}>Изменить дату</Button>}
            <StepButtonsTransition
              type={cardName}
              transition={transition}
              transitionRequired={transitionRequired}
              isBusy={isStageTransitioning}
            />
          </Space>
        </TaskWrapper>
        <MapContent>
          <Form
            {...formItemLayout}
            layout="horizontal"
            form={form}
            fields={[
              {
                name: 'schema',
                value: selectedSchema,
              },
            ]}
            scrollToFirstError={true}
          >
            {pageErrors.length > 0 ? (
              <AlertWrapper>
                <Alert
                  message="При выполнении операции возникла ошибка:"
                  showIcon
                  type="error"
                  description={pageErrors.join('. ')}
                />
              </AlertWrapper>
            ) : null}
            {!isDataLoading ? (
              <Form.Item name="items">
                <StepCollectionObject type={cardName}/>
                {matchedJSONSchema && UISchema && (
                  <DefaultJsonForm
                    formData={formDataRef.current}
                    schema={matchedJSONSchema}
                    onChange={onFormData}
                    customTabs={custumTabs}
                    UISchema={UISchema}
                  />
                )}
              </Form.Item >
            ) : (
              <Skeleton active />
            )}
          </Form>
        </MapContent>
      </MapWrapper>
    </B2BLayout>
  )
}
